export const GAMES_LIMIT = 20
export const EXPLORE_GAMES_LIMIT = 20
